import React from 'react'
import ChairOneSeatOneBackImage from '../../../../assets/products/chair-1-seat-1-back.webp'

const ChairWithBack = () => {
  return (
    <svg
      width="600"
      height="493"
      viewBox="0 0 700 550"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <image x="-290" y="-93" width="1080" height="760" xlinkHref={ChairOneSeatOneBackImage} />
      <g id="Group 1493">
        <g id="E-Comp">
          <g filter="url(#filter0_d_5401_8524)">
            <rect
              id="E-Background"
              x="480.945"
              y="46.5695"
              width="41"
              height="41"
              rx="20.5"
              transform="rotate(146.495 480.945 46.5695)"
              fill="transparent"
            />
            <path
              id="E-Text"
              d="M457.203 45.2351V47.2917H450.391V45.2351H457.203ZM451.252 34.4949V47.2917H448.616V34.4949H451.252ZM456.315 39.7068V41.7107H450.391V39.7068H456.315ZM457.194 34.4949V36.5603H450.391V34.4949H457.194Z"
              fill="#FFFFFF99"
            />
          </g>
          <path
            id="E-Line"
            d="M431.583 75.9065C431.854 75.9615 432.118 75.7867 432.173 75.5161L433.07 71.1064C433.125 70.8358 432.95 70.5718 432.68 70.5168C432.409 70.4618 432.145 70.6365 432.09 70.9071L431.293 74.8269L427.373 74.0298C427.102 73.9747 426.838 74.1495 426.783 74.4201C426.728 74.6907 426.903 74.9547 427.174 75.0097L431.583 75.9065ZM412.616 45.9747C412.346 45.9197 412.082 46.0944 412.027 46.365L411.13 50.7748C411.075 51.0454 411.25 51.3094 411.52 51.3644C411.791 51.4194 412.055 51.2447 412.11 50.9741L412.907 47.0543L416.827 47.8514C417.097 47.9064 417.361 47.7317 417.416 47.4611C417.471 47.1905 417.297 46.9265 417.026 46.8715L412.616 45.9747ZM432.1 75.1405L430.503 72.7278L429.669 73.2799L431.266 75.6925L432.1 75.1405ZM427.308 67.9025L424.114 63.0772L423.28 63.6293L426.475 68.4546L427.308 67.9025ZM420.92 58.2519L417.725 53.4266L416.891 53.9786L420.086 58.8039L420.92 58.2519ZM414.531 48.6013L412.933 46.1887L412.1 46.7407L413.697 49.1533L414.531 48.6013Z"
            fill="#FFFFFF99"
          />
        </g>
        <g id="D-Comp">
          <g filter="url(#filter1_d_5401_8524)">
            <rect
              id="D-Background"
              x="30.3584"
              y="147.151"
              width="41"
              height="41"
              rx="20.5"
              transform="rotate(-1.30105 30.3584 147.151)"
              fill="transparent"
            />
            <path
              id="D-Text"
              d="M50.5361 173.681H47.75L47.7676 171.624H50.5361C51.2275 171.624 51.8105 171.469 52.2852 171.158C52.7598 170.842 53.1172 170.382 53.3574 169.778C53.6035 169.175 53.7266 168.445 53.7266 167.59V166.966C53.7266 166.31 53.6562 165.733 53.5156 165.234C53.3809 164.736 53.1787 164.318 52.9092 163.978C52.6396 163.638 52.3086 163.383 51.916 163.213C51.5234 163.037 51.0723 162.949 50.5625 162.949H47.6973V160.884H50.5625C51.418 160.884 52.2002 161.03 52.9092 161.323C53.624 161.61 54.2422 162.024 54.7637 162.563C55.2852 163.102 55.6865 163.746 55.9678 164.496C56.2549 165.24 56.3984 166.069 56.3984 166.984V167.59C56.3984 168.498 56.2549 169.327 55.9678 170.077C55.6865 170.827 55.2852 171.472 54.7637 172.011C54.248 172.544 53.6299 172.957 52.9092 173.25C52.1943 173.537 51.4033 173.681 50.5361 173.681ZM49.2441 160.884V173.681H46.6074V160.884H49.2441Z"
              fill="#FFFFFF99"
            />
          </g>
          <path
            id="D-Line"
            d="M86.6404 99.3206C86.4407 99.1299 86.1242 99.137 85.9334 99.3367L82.8245 102.59C82.6337 102.79 82.6409 103.106 82.8406 103.297C83.0402 103.488 83.3567 103.481 83.5475 103.281L86.311 100.389L89.2029 103.153C89.4025 103.343 89.719 103.336 89.9098 103.136C90.1006 102.937 90.0934 102.62 89.8938 102.43L86.6404 99.3206ZM88.9778 233.383C89.1775 233.574 89.494 233.567 89.6848 233.367L92.7937 230.114C92.9844 229.914 92.9773 229.598 92.7776 229.407C92.578 229.216 92.2615 229.223 92.0707 229.423L89.3072 232.315L86.4153 229.551C86.2157 229.361 85.8991 229.368 85.7084 229.568C85.5176 229.767 85.5248 230.084 85.7244 230.274L88.9778 233.383ZM85.7951 99.6935L85.8533 102.258L86.853 102.235L86.7948 99.6708L85.7951 99.6935ZM85.9698 107.386L86.0862 112.515L87.086 112.492L86.9695 107.363L85.9698 107.386ZM86.2027 117.643L86.3192 122.772L87.3189 122.749L87.2025 117.62L86.2027 117.643ZM86.4357 127.9L86.5521 133.028L87.5519 133.006L87.4354 127.877L86.4357 127.9ZM86.6686 138.157L86.7851 143.285L87.7848 143.263L87.6684 138.134L86.6686 138.157ZM86.9016 148.414L87.018 153.542L88.0178 153.52L87.9013 148.391L86.9016 148.414ZM87.1345 158.671L87.251 163.799L88.2507 163.776L88.1343 158.648L87.1345 158.671ZM87.3675 168.928L87.4839 174.056L88.4837 174.033L88.3672 168.905L87.3675 168.928ZM87.6004 179.184L87.7169 184.313L88.7166 184.29L88.6002 179.162L87.6004 179.184ZM87.8334 189.441L87.9498 194.57L88.9496 194.547L88.8331 189.419L87.8334 189.441ZM88.0663 199.698L88.1828 204.827L89.1825 204.804L89.0661 199.676L88.0663 199.698ZM88.2993 209.955L88.4157 215.084L89.4155 215.061L89.299 209.932L88.2993 209.955ZM88.5322 220.212L88.6487 225.341L89.6484 225.318L89.532 220.189L88.5322 220.212ZM88.7652 230.469L88.8234 233.033L89.8231 233.011L89.7649 230.446L88.7652 230.469Z"
            fill="#FFFFFF99"
          />
        </g>
        <g id="C-Comp">
          <g filter="url(#filter2_d_5401_8524)">
            <rect
              id="C-Background"
              x="59.689"
              y="369.805"
              width="41"
              height="41"
              rx="20.5"
              transform="rotate(-22.6637 59.689 369.805)"
              fill="transparent"
            />
            <path
              id="C-Text"
              d="M89.1768 383.078H91.8047C91.752 383.94 91.5146 384.704 91.0928 385.372C90.6768 386.04 90.0938 386.562 89.3438 386.937C88.5996 387.312 87.7031 387.499 86.6543 387.499C85.834 387.499 85.0986 387.359 84.4482 387.077C83.7979 386.79 83.2412 386.38 82.7783 385.847C82.3213 385.314 81.9727 384.669 81.7324 383.913C81.4922 383.157 81.3721 382.311 81.3721 381.373V380.485C81.3721 379.548 81.4951 378.701 81.7412 377.945C81.9932 377.184 82.3506 376.536 82.8135 376.003C83.2822 375.47 83.8418 375.06 84.4922 374.773C85.1426 374.485 85.8691 374.342 86.6719 374.342C87.7383 374.342 88.6377 374.535 89.3701 374.922C90.1084 375.309 90.6797 375.842 91.084 376.522C91.4941 377.201 91.7402 377.975 91.8223 378.842H89.1855C89.1562 378.326 89.0537 377.89 88.8779 377.532C88.7021 377.169 88.4355 376.897 88.0781 376.715C87.7266 376.527 87.2578 376.434 86.6719 376.434C86.2324 376.434 85.8486 376.516 85.5205 376.68C85.1924 376.844 84.917 377.093 84.6943 377.427C84.4717 377.761 84.3047 378.183 84.1934 378.693C84.0879 379.196 84.0352 379.788 84.0352 380.468V381.373C84.0352 382.035 84.085 382.618 84.1846 383.122C84.2842 383.62 84.4365 384.042 84.6416 384.388C84.8525 384.728 85.1221 384.985 85.4502 385.161C85.7842 385.331 86.1855 385.416 86.6543 385.416C87.2051 385.416 87.6592 385.328 88.0166 385.152C88.374 384.977 88.6465 384.716 88.834 384.37C89.0273 384.025 89.1416 383.594 89.1768 383.078Z"
              fill="#FFFFFF99"
            />
          </g>
          <path
            id="C-Line"
            d="M87.7887 288.253C87.5332 288.148 87.2411 288.27 87.1361 288.526L85.426 292.688C85.321 292.943 85.443 293.235 85.6984 293.34C85.9538 293.445 86.246 293.323 86.3509 293.068L87.8711 289.368L91.571 290.888C91.8264 290.993 92.1185 290.871 92.2235 290.616C92.3284 290.36 92.2064 290.068 91.951 289.963L87.7887 288.253ZM152.585 445.265C152.84 445.37 153.133 445.248 153.238 444.993L154.948 440.83C155.053 440.575 154.931 440.283 154.675 440.178C154.42 440.073 154.128 440.195 154.023 440.45L152.503 444.15L148.803 442.63C148.547 442.525 148.255 442.647 148.15 442.903C148.045 443.158 148.167 443.45 148.423 443.555L152.585 445.265ZM87.1372 288.908L88.0957 291.204L89.0185 290.818L88.06 288.523L87.1372 288.908ZM90.0127 295.794L91.9296 300.385L92.8524 300L90.9355 295.409L90.0127 295.794ZM93.8466 304.976L95.7635 309.567L96.6863 309.182L94.7694 304.591L93.8466 304.976ZM97.6805 314.158L99.5974 318.748L100.52 318.363L98.6033 313.772L97.6805 314.158ZM101.514 323.339L103.431 327.93L104.354 327.545L102.437 322.954L101.514 323.339ZM105.348 332.521L107.265 337.112L108.188 336.726L106.271 332.136L105.348 332.521ZM109.182 341.702L111.099 346.293L112.022 345.908L110.105 341.317L109.182 341.702ZM113.016 350.884L114.933 355.475L115.856 355.09L113.939 350.499L113.016 350.884ZM116.85 360.066L118.767 364.656L119.69 364.271L117.773 359.68L116.85 360.066ZM120.684 369.247L122.601 373.838L123.524 373.453L121.607 368.862L120.684 369.247ZM124.518 378.429L126.435 383.02L127.358 382.634L125.441 378.044L124.518 378.429ZM128.352 387.61L130.269 392.201L131.191 391.816L129.275 387.225L128.352 387.61ZM132.186 396.792L134.103 401.383L135.025 400.998L133.108 396.407L132.186 396.792ZM136.02 405.974L137.937 410.564L138.859 410.179L136.942 405.588L136.02 405.974ZM139.853 415.155L141.77 419.746L142.693 419.361L140.776 414.77L139.853 415.155ZM143.687 424.337L145.604 428.928L146.527 428.542L144.61 423.952L143.687 424.337ZM147.521 433.518L149.438 438.109L150.361 437.724L148.444 433.133L147.521 433.518ZM151.355 442.7L152.314 444.995L153.236 444.61L152.278 442.315L151.355 442.7Z"
            fill="#FFFFFF99"
          />
        </g>
        <g id="B-Comp">
          <g filter="url(#filter3_d_5401_8524)">
            <rect
              id="B-Background"
              x="322.363"
              y="507.4"
              width="41"
              height="41"
              rx="20.5"
              transform="rotate(-101.097 322.363 507.4)"
              fill="transparent"
            />
            <path
              id="B-Text"
              d="M338.937 484.222L335.65 484.222L335.633 482.411L338.393 482.411C338.879 482.411 339.277 482.349 339.588 482.226C339.898 482.098 340.13 481.913 340.282 481.673C340.44 481.427 340.52 481.128 340.52 480.776C340.52 480.378 340.443 480.056 340.291 479.809C340.145 479.563 339.913 479.385 339.597 479.273C339.286 479.162 338.885 479.106 338.393 479.106L336.564 479.106L336.564 489.838L333.928 489.838L333.928 477.041L338.393 477.041C339.137 477.041 339.802 477.111 340.388 477.252C340.979 477.392 341.48 477.606 341.891 477.893C342.301 478.181 342.614 478.544 342.831 478.983C343.048 479.417 343.156 479.932 343.156 480.53C343.156 481.057 343.036 481.544 342.796 481.989C342.562 482.434 342.189 482.798 341.68 483.079C341.176 483.36 340.517 483.516 339.702 483.545L338.937 484.222ZM338.823 489.838L334.93 489.838L335.958 487.781L338.823 487.781C339.286 487.781 339.664 487.708 339.957 487.561C340.25 487.409 340.467 487.204 340.607 486.946C340.748 486.688 340.818 486.392 340.818 486.058C340.818 485.683 340.754 485.358 340.625 485.083C340.502 484.807 340.303 484.597 340.027 484.45C339.752 484.298 339.389 484.222 338.937 484.222L336.397 484.222L336.415 482.411L339.579 482.411L340.186 483.123C340.965 483.111 341.592 483.249 342.066 483.536C342.547 483.817 342.896 484.183 343.112 484.635C343.335 485.086 343.446 485.569 343.446 486.085C343.446 486.905 343.268 487.597 342.91 488.159C342.553 488.716 342.028 489.135 341.337 489.416C340.651 489.697 339.813 489.838 338.823 489.838Z"
              fill="#FFFFFF99"
            />
          </g>
          <path
            id="B-Line"
            d="M202.936 472.378C202.782 472.608 202.843 472.918 203.072 473.072L206.807 475.582C207.036 475.736 207.347 475.675 207.501 475.446C207.655 475.217 207.594 474.906 207.365 474.752L204.045 472.521L206.276 469.201C206.43 468.972 206.369 468.661 206.14 468.507C205.911 468.353 205.6 468.414 205.446 468.644L202.936 472.378ZM460.081 422.662C460.235 422.433 460.174 422.122 459.945 421.968L456.21 419.458C455.981 419.304 455.67 419.365 455.516 419.594C455.362 419.823 455.423 420.134 455.652 420.288L458.972 422.519L456.741 425.839C456.587 426.068 456.648 426.379 456.877 426.533C457.106 426.687 457.417 426.626 457.571 426.397L460.081 422.662ZM203.447 473.148L205.912 472.665L205.719 471.683L203.255 472.167L203.447 473.148ZM210.841 471.698L215.77 470.731L215.578 469.75L210.649 470.716L210.841 471.698ZM220.699 469.764L225.628 468.797L225.436 467.816L220.507 468.783L220.699 469.764ZM230.558 467.831L235.487 466.864L235.294 465.882L230.365 466.849L230.558 467.831ZM240.416 465.897L245.345 464.93L245.152 463.949L240.223 464.916L240.416 465.897ZM250.274 463.963L255.203 462.996L255.011 462.015L250.082 462.982L250.274 463.963ZM260.132 462.03L265.061 461.063L264.869 460.082L259.94 461.048L260.132 462.03ZM269.991 460.096L274.92 459.129L274.727 458.148L269.798 459.115L269.991 460.096ZM279.849 458.162L284.778 457.196L284.585 456.214L279.656 457.181L279.849 458.162ZM289.707 456.229L294.636 455.262L294.444 454.281L289.515 455.247L289.707 456.229ZM299.565 454.295L304.494 453.328L304.302 452.347L299.373 453.314L299.565 454.295ZM309.424 452.362L314.353 451.395L314.16 450.413L309.231 451.38L309.424 452.362ZM319.282 450.428L324.211 449.461L324.018 448.48L319.089 449.447L319.282 450.428ZM329.14 448.494L334.069 447.527L333.877 446.546L328.948 447.513L329.14 448.494ZM338.998 446.561L343.927 445.594L343.735 444.613L338.806 445.579L338.998 446.561ZM348.857 444.627L353.786 443.66L353.593 442.679L348.664 443.646L348.857 444.627ZM358.715 442.693L363.644 441.727L363.452 440.745L358.522 441.712L358.715 442.693ZM368.573 440.76L373.502 439.793L373.31 438.812L368.381 439.778L368.573 440.76ZM378.431 438.826L383.361 437.859L383.168 436.878L378.239 437.845L378.431 438.826ZM388.29 436.892L393.219 435.926L393.026 434.944L388.097 435.911L388.29 436.892ZM398.148 434.959L403.077 433.992L402.885 433.011L397.955 433.978L398.148 434.959ZM408.006 433.025L412.935 432.058L412.743 431.077L407.814 432.044L408.006 433.025ZM417.864 431.092L422.794 430.125L422.601 429.143L417.672 430.11L417.864 431.092ZM427.723 429.158L432.652 428.191L432.459 427.21L427.53 428.177L427.723 429.158ZM437.581 427.224L442.51 426.258L442.318 425.276L437.389 426.243L437.581 427.224ZM447.439 425.291L452.368 424.324L452.176 423.343L447.247 424.309L447.439 425.291ZM457.298 423.357L459.762 422.874L459.57 421.892L457.105 422.376L457.298 423.357Z"
            fill="#FFFFFF99"
          />
        </g>
        <g id="A-Comp">
          <g filter="url(#filter4_d_5401_8524)">
            <rect
              id="A-Background"
              x="534.118"
              y="393.909"
              width="41"
              height="41"
              rx="20.5"
              transform="rotate(-174.18 534.118 393.909)"
              fill="transparent"
            />
            <path
              id="A-Text"
              d="M516.102 367.328L512.622 377.936H509.818L514.573 365.139H516.357L516.102 367.328ZM518.994 377.936L515.504 367.328L515.223 365.139H517.025L521.806 377.936H518.994ZM518.835 373.172V375.238H512.077V373.172H518.835Z"
              fill="#FFFFFF99"
            />
          </g>
          <path
            id="A-Line"
            d="M476.529 393.301C476.704 393.515 477.019 393.547 477.233 393.373L480.721 390.53C480.935 390.356 480.967 390.041 480.793 389.827C480.618 389.613 480.303 389.58 480.089 389.755L476.989 392.282L474.462 389.181C474.287 388.967 473.972 388.935 473.758 389.11C473.544 389.284 473.512 389.599 473.686 389.813L476.529 393.301ZM482.452 342.169C482.278 341.954 481.963 341.922 481.749 342.097L478.26 344.94C478.046 345.114 478.014 345.429 478.189 345.643C478.363 345.857 478.678 345.889 478.892 345.715L481.993 343.188L484.52 346.289C484.694 346.503 485.009 346.535 485.223 346.36C485.437 346.186 485.469 345.871 485.295 345.657L482.452 342.169ZM477.414 393.036L477.672 390.511L476.677 390.41L476.42 392.935L477.414 393.036ZM478.187 385.461L478.701 380.411L477.706 380.309L477.192 385.36L478.187 385.461ZM479.216 375.361L479.731 370.311L478.736 370.209L478.221 375.259L479.216 375.361ZM480.246 365.261L480.76 360.21L479.765 360.109L479.251 365.159L480.246 365.261ZM481.275 355.16L481.79 350.11L480.795 350.009L480.28 355.059L481.275 355.16ZM482.305 345.06L482.562 342.535L481.567 342.434L481.31 344.959L482.305 345.06Z"
            fill="#FFFFFF99"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_5401_8524"
          x="394.125"
          y="-7.6178"
          width="116.82"
          height="116.82"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="15" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5401_8524" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5401_8524"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_5401_8524"
          x="0.358398"
          y="126.221"
          width="101.92"
          height="101.92"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="15" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5401_8524" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5401_8524"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_5401_8524"
          x="29.689"
          y="334.007"
          width="113.632"
          height="113.632"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="15" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5401_8524" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5401_8524"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_d_5401_8524"
          x="284.471"
          y="439.275"
          width="108.125"
          height="108.125"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="15" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5401_8524" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5401_8524"
            result="shape"
          />
        </filter>
        <filter
          id="filter4_d_5401_8524"
          x="463.33"
          y="328.963"
          width="104.946"
          height="104.946"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="15" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5401_8524" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5401_8524"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default ChairWithBack
